module.exports = __webpack_public_path__ + "img/1-19.bbc98f5e.png";